/*! Copyright 2016 to eternity: Dash Agency | http://dashagency.com/ */


/*------------------------------------*\
    Utilities and helper scripts
\*------------------------------------*/
var exists = require('./base/exists.js');

require('./base/utilities.js')();

require('./base/html-class.js')();





/*------------------------------------*\
    Blocks
\*------------------------------------*/

if(exists('.js-accordion-heading'))
    require('./blocks/accordion.js')();

if(exists('.js-calculator-option'))
    require('./blocks/calculator.js')();

if(exists('.js-copy-btn'))
    require('./blocks/copy.js')();

if(exists('.js-filter-menu-toggle'))
    require('./blocks/filter.js')();

if(exists('.js-shop-thumb-set'))
    require('./blocks/filter-shop.js')();

if(true)
    require('./blocks/megamenu-dropdown.js')();

if(exists('.js-hover'))
    require('./blocks/hover.js')();

if(exists('.js-input-placeholder'))
    require('./blocks/input.js')();

if(exists('.js-know-your-suit-video'))
    require('./blocks/know-your-suit.js')();

if(exists('.js-get-educated-tab'))
    require('./blocks/get-educated.js')();

if(exists('.js-magnify'))
    require('./blocks/magnify.js')();

if(true)
    require('./blocks/mask.js')();

if(exists('.js-modal-trigger'))
    require('./blocks/modal.js')();

if(exists('.js-product-info'))
    require('./blocks/product-n-customize.js')();

if(exists('.js-popup-trigger'))
    require('./blocks/popup.js')();

if(exists('.js-scroll'))
    require('./blocks/scroll.js')();

if(true)
    require('./blocks/animate-waypoint.js')();

if(true)
    require('./blocks/skrollr.js')();


if(exists('.js-select2'))
    require('./blocks/select2.js')();

if(exists('.js-selectize'))
    require('./blocks/selectize.js')();

if(exists('.swiper-container'))
    require('./blocks/swiper.js')();

if(exists('.js-step-trigger'))
    require('./blocks/steps.js')();

if(true)
    require('./blocks/sticky.js')();

if(exists('.js-tab'))
    require('./blocks/tabs.js')();

if(exists('.js-tooltip'))
    require('./blocks/tooltip.js')();

//if(exists('')){ require('')(); }







/*------------------------------------*\
    Integration
    with API
\*------------------------------------*/

if(true)
    require('./integration/eph-ajax.js')();

if(true)
    require('./integration/cart-eph.js')();

if(true)
    require('./integration/cart.js')();

if(true)
    require('./integration/checkout-flow.js')();

if(true)
    require('./integration/checks.js')();

if(true)
    require('./integration/wishlist.js')();

if(exists('.js-login-form'))
    require('./integration/login.js')();

if(exists('.js-register-form'))
    require('./integration/signup.js')();

if(exists('.js-home-address-form'))
    require('./integration/addresses.js')();

if(exists('[js-same-as-billing-address-input]'))
    require('./integration/same-as-billing-address.js')();

if(exists('.js-basic-info-change-form'))
    require('./integration/change-basic-info.js')();

if(exists('.js-password-change-form'))
    require('./integration/change-password.js')();

if(exists('.js-profile-pic-form'))
    require('./integration/profile-pic.js')();

if(true)
    require('./integration/measurements_new_measurement.js')();

if(true)
    require('./integration/measurements_from_fm.js')();

if(true)
    require('./integration/measurements_edit.js')();

if(true)
    require('./integration/alterations.js')();

if(true)
    require('./integration/monograms.js')();

if(true)
    require('./integration/zoom-liner.js')();

if(true)
    require('./integration/customize-order.js')();

if(true)
    require('./integration/giftcard_select.js')();

if(exists('[js-sd-form]'))
    require('./integration/style-discovery.js')();

if(exists('[js-style-advice]'))
    require('./integration/style-advice.js')();

if(exists('[js-form-eph-join-our-team]'))
    require('./integration/form-join-our-team.js')();

if(exists('[js-form-eph-contact-us]'))
    require('./integration/form-contact-us.js')();

if(exists('[js-form-eph-contact-us-wedding-page]'))
    require('./integration/form-contact-us-wedding-page.js')();

if(exists('[js-psr-contact-form]'))
    require('./integration/form-psr-contact.js')();



/*------------------------------------*\
    redirection checks
\*------------------------------------*/
var redirectUri = Cookies.get('LOGIN_SIGNUP_REDIRECT_URI');
if (redirectUri) {
    Cookies.remove('LOGIN_SIGNUP_REDIRECT_URI');
    redirectUri = '/' + redirectUri
    location.href = redirectUri.split('//').join('/')
    //console.log('Redirecting to ' + redirectUri)
}




/*------------------------------------*\
    Debug
\*------------------------------------*/
//require('./debug/react-get-numbers.jsx')();



// WEBPACK FOOTER //
// ./js-source/global.js